module.exports = __webpack_public_path__ + "img/11.18ecffe9.jpg";